<template>
  <b-modal
    v-model="showModal"
    size="xl"
    :title="`Chi tiết lịch sử phiếu kho - #${historyRecord.id || ''}`"
    header-bg-variant="light"
    scrollable
    no-close-on-backdrop
    @hidden="onModalHidden"
  >
    <div v-if="historyRecord">
      <h5 class="bold-text">Thông tin log</h5>
      <hr />
      <b-row class="mb-3">
        <b-col md="4">
          <p class="header-color mb-1">Hành động</p>
          <p class="mb-3">{{ historyRecord.actionName || '—' }}</p>
          <p class="header-color mb-1">Mã tham chiếu</p>
          <p>{{ historyRecord.referenceId || '—' }}</p>
        </b-col>
        <b-col md="4">
          <p class="header-color mb-1">Người thao tác</p>
          <p class="mb-3 font-weight-bold">{{ historyRecord.employeeName || '—' }}</p>
          <p class="header-color mb-1">Thời gian</p>
          <p>{{ historyRecord.createdAt || '—' }}</p>
        </b-col>
      </b-row>

      <h5 class="bold-text">Thông tin thay đổi</h5>
      <hr />

      <div v-if="!headerRows.length && !detailRows.length" class="text-muted">
        Không có dữ liệu thay đổi.
      </div>

      <div v-if="headerRows.length" class="mb-4">
        <table class="table table-bordered table-sm table-hover mb-0 history-diff-table">
          <thead class="bg-light">
            <tr>
              <th style="width: 22%">Thông tin phiếu</th>
              <th style="width: 39%">Trước khi sửa</th>
              <th style="width: 39%">Sau khi sửa</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in headerRows" :key="row.key">
              <th class="header-color">{{ row.label }}</th>
              <td>{{ row.before }}</td>
              <td class="history-diff-table__after">{{ row.after }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="detailRows.length">
        <h6 class="font-weight-bold mb-3">Chi tiết sản phẩm</h6>
        <div
          v-for="product in detailRows"
          :key="product.productKey"
          class="detail-diff-card mb-3"
        >
          <div class="detail-diff-card__header">
            <span
              class="detail-diff-card__badge"
              :class="`detail-diff-card__badge--${product.changeType}`"
            >
              {{ changeTypeLabel(product.changeType) }}
            </span>
            <span class="detail-diff-card__title">{{ product.label }}</span>
          </div>
          <table class="table table-bordered table-sm mb-0 history-diff-table">
            <thead class="bg-light">
              <tr>
                <th style="width: 18%">Trường</th>
                <th style="width: 41%">Trước khi sửa</th>
                <th style="width: 41%">Sau khi sửa</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="field in visibleFields(product)"
                :key="field.key"
                :class="{ 'history-diff-table__row-changed': field.changed }"
              >
                <th class="header-color">{{ field.label }}</th>
                <td>
                  <ImeiHistoryCell
                    v-if="field.format === 'imei'"
                    :codes="field.before"
                    :imei-diff="field.imeiDiff"
                    side="before"
                  />
                  <span v-else>{{ displayText(field.before) }}</span>
                </td>
                <td class="history-diff-table__after">
                  <ImeiHistoryCell
                    v-if="field.format === 'imei'"
                    :codes="field.after"
                    :imei-diff="field.imeiDiff"
                    side="after"
                  />
                  <span v-else>{{ displayText(field.after) }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <template #modal-footer="{ close }">
      <b-button variant="secondary" size="sm" @click="close()">Đóng</b-button>
    </template>
  </b-modal>
</template>

<script>
  import {
    buildStockSlipHeaderDiffRows,
    buildStockSlipDetailDiffRows,
  } from './stockSlipHistoryDiff'
  import ImeiHistoryCell from './ImeiHistoryCell.vue'

  export default {
    name: 'StockSlipHistoryModal',
    components: { ImeiHistoryCell },
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      historyRecord: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        showModal: false,
      }
    },
    computed: {
      headerRows() {
        if (!this.historyRecord) return []
        return buildStockSlipHeaderDiffRows(
          this.historyRecord.originalValue,
          this.historyRecord.newValue,
        )
      },
      detailRows() {
        if (!this.historyRecord) return []
        return buildStockSlipDetailDiffRows(
          this.historyRecord.originalValue,
          this.historyRecord.newValue,
        )
      },
    },
    watch: {
      show(value) {
        this.showModal = value
      },
      showModal(value) {
        this.$emit('update:show', value)
      },
    },
    methods: {
      onModalHidden() {
        this.$emit('hidden')
      },
      changeTypeLabel(type) {
        if (type === 'added') return 'Thêm mới'
        if (type === 'removed') return 'Đã xóa'
        return 'Thay đổi'
      },
      visibleFields(product) {
        if (product.changeType === 'modified') {
          return product.fields.filter((f) => f.changed)
        }
        return product.fields
      },
      displayText(value) {
        if (value == null || value === '') return '—'
        return value
      },
    },
  }
</script>

<style scoped>
  .header-color {
    color: #6c757d;
    font-weight: 600;
  }
  .bold-text {
    font-weight: 600;
  }
  .history-diff-table__after {
    background-color: #fff8e6;
  }
  .history-diff-table__row-changed {
    background-color: #fffdf5;
  }
  .detail-diff-card {
    border: 1px solid #e4e6ef;
    border-radius: 0.42rem;
    overflow: hidden;
  }
  .detail-diff-card__header {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 10px 12px;
    background: #f9fafb;
    border-bottom: 1px solid #e4e6ef;
  }
  .detail-diff-card__title {
    font-size: 13px;
    font-weight: 600;
    color: #181c32;
    line-height: 1.4;
    word-break: break-word;
  }
  .detail-diff-card__badge {
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 4px;
    margin-top: 2px;
  }
  .detail-diff-card__badge--modified {
    background: #fff3cd;
    color: #856404;
  }
  .detail-diff-card__badge--added {
    background: #d4edda;
    color: #155724;
  }
  .detail-diff-card__badge--removed {
    background: #f8d7da;
    color: #721c24;
  }
</style>
